import {useMemo, useState} from "react";
import {Card, Col, Container, Row} from "react-bootstrap";
import PageLayout from "../../../components/layouts/PageLayout";
import DataTable from "../../../components/dataTable/DataTable";
import {MenuType, SubMenuType} from "../../../utils/helpers/constants";
import {useGetQuickPaymentRequestQuery} from "../../../store/slices/backoffice.slice";
import { CellContext, ColumnDef, ColumnHelper, createColumnHelper} from "@tanstack/react-table";
import { QuickPaymentRequestsColumn } from "../../../components/dataTable/QuickPaymentRequestsColumn";
import { PROD_BASEURL } from "../../../utils/services/axios.service";
import { DropDown, DropDownItem } from "../../../components/modules/DropDown";
import { useNavigate } from "react-router-dom";

const QuickPaymentRequests = () => {
  const [size] = useState(20);
  const reference = window.location.hostname === PROD_BASEURL ? "TRU_Z9WE" : "TRU_H0D4"
  const [pageIndex, setPageIndex] = useState(1);
  const navigate = useNavigate();

  const {data: requests, isLoading, isFetching} = useGetQuickPaymentRequestQuery({reference: reference, filter:`?size=${size}&page=${pageIndex}`});


  const column: ColumnHelper<IQuickPaymentRequest> = createColumnHelper<IQuickPaymentRequest>();
    const actionColumn: ColumnDef<IQuickPaymentRequest, string> = (column.accessor('id', {
      header: () => <span>Action</span>,
      enableSorting: false,
      cell: (info: CellContext<IQuickPaymentRequest, string>) => {
        let request: IQuickPaymentRequest = info.row.original;
        return (
          <div className="btn-group">
            <DropDown buttonText="Actions" variant="primary" buttonSize="sm">
              <DropDownItem text="View Info"
                            onclick={() => navigate(`/${MenuType.SUPPLY}/${SubMenuType.QUICKPAY}/requests/${request.id}`, {state: request})}/>
              {/* <DropDownItem text="Status History" onclick={() => openLoanCanvasStatusRender(request)}/> */}
            </DropDown>
          </div>
        )
      }
    }))
  const columns: ColumnDef<IQuickPaymentRequest, string>[] = useMemo(() => [...QuickPaymentRequestsColumn, actionColumn], []);



  return (
    <PageLayout active={MenuType.SUPPLY} title="Quick Payment Requests" loading={isLoading}>
      <Container fluid>

        <Row>
          <Col xs={12}>
            <Card className="card-body">
              <h5 className="card-title">Quick Payment Request</h5>
              <DataTable columns={columns} data={requests?.data ?? []} pageIndex={pageIndex} size={size}
                         count={Number(requests?.pagination?.total) ?? 0} loadingState={isFetching}
                         setPageIndex={(index: number) => setPageIndex(index)}/>
            </Card>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  )
}

export default QuickPaymentRequests;
